export const authEndpoints = {
  // Public endpoints
  validateOtp: '/public/v1/auth/validate-otp',
  login: '/public/v1/auth/login',
  resendOtp: '/public/v1/auth/resend-otp',
  registrationStatus: '/public/v1/auth/registration-status',
  forgotPassword: '/public/v1/auth/forgot-password',
  resendRecoveryEmail: '/public/v1/auth/resend-recovery-email',
  verifyRecoveryOtp: '/public/v1/auth/verify-recovery-otp',
  initRegistration: '/public/v1/auth/register/init',
  finalizeRegistration: '/public/v1/auth/register/finalize',
  refreshToken: '/public/v1/auth/refresh',
  verifyRecoveryCode: '/public/v1/auth/verify-recovery-otp',
  recoverySendTwoFactor: '/public/v1/auth/recovery/2fa/send',
  recoveryVerifyTwoFactor: '/public/v1/auth/recovery/2fa/verify',

  // Private endpoints
  setPassword: '/private/v1/auth/set-password',
  resetPassword: '/private/v1/auth/reset-password',
  sendEmailCode: '/private/v1/auth/send-email-code',
  verifyEmail: '/private/v1/auth/verify-email',
  sendPhoneCode: '/private/v1/auth/send-phone-code',
  verifyPhone: '/private/v1/auth/verify-phone',
  chooseTwoFactorMethod: '/public/v1/auth/2fa/send',
  resendTwoFactor: '/public/v1/auth/2fa/resend',
  verifyTwoFactor: '/public/v1/auth/2fa/verify',
  initLogin: '/public/v1/auth/login/init',
  finalizeLogin: '/public/v1/auth/login/finalize',
  // OPAQUE OPRF round-trip for a user who ALREADY holds a credential (change
  // password). `register/init` cannot be reused — it 409s anyone with an
  // existing credential. cqrs SDB-733 (InitCredentialRotationController).
  rotateCredentialInit: '/private/v1/auth/credentials/rotate/init',
  registerMlkemKeys: (id: string) => `/private/v1/auth/registerMlkemKeys/${id}`,
  updateMlkemKeys: (id: string) => `/private/v1/auth/mlkemKeys/${id}`,
} as const;

export type AuthEndpointKey = keyof typeof authEndpoints;
